import React, { lazy } from 'react';
const tomes = [{
  label: 'Tomo 1',
  sublabel: 'Morfofisiología Extrema',
  image: 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1777816815/Gemini_Generated_Image_7r9e7d7r9e7d7r9e_aylrsy.webp'
}, {
  label: 'Tomo 2',
  sublabel: 'Biomecánica y Evaluación',
  image: 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1777816923/Gemini_Generated_Image_m7zd5pm7zd5pm7zd_enndna.webp'
}, {
  label: 'Tomo 3',
  sublabel: 'Agentes Físicos',
  image: 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1777817667/Gemini_Generated_Image_n63hd0n63hd0n63h_hk9tji.webp'
}, {
  label: 'Tomo 4',
  sublabel: 'Clínica Kinésica Superior',
  image: 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1777817748/Gemini_Generated_Image_d67s6kd67s6kd67s_ycqzrx.webp'
}, {
  label: 'Tomo 5',
  sublabel: 'Técnicas Manuales',
  image: 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1777817574/Gemini_Generated_Image_ionx5kionx5kionx_khojaf.webp'
}, {
  label: 'Tomo 6',
  sublabel: 'Práctica Hospitalaria',
  image: 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1777817888/Gemini_Generated_Image_nkoztznkoztznkoz_np7ko9.webp'
}];
const features = ['Todo el contenido de la carrera organizado por área y materia', 'Protocolos de evaluación kinésica y parámetros clínicos listos para usar', 'Casos clínicos resueltos paso a paso por patología y región', 'Guías de prácticas hospitalarias y TPs listos para presentar'];
export function ProductShowcase() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900 text-base leading-6" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(255,255,255) 0%, rgb(255,255,255) 15%, rgb(239,246,255) 85%, rgb(219,234,254) 100%)'
  }} data-id="element-252">
      <div className="mx-auto max-w-4xl text-center" data-id="element-253">
        {/* Badge */}
        <div className="mb-6 inline-flex items-center gap-2 text-xs font-bold tracking-wide text-blue-700 border border-blue-700/50 bg-blue-700/5 rounded-full px-4 py-1.5" data-id="element-254">
          🏆 El sistema de estudio más completo para estudiantes de Kinesiología
          en Argentina
        </div>

        {/* Subtitle */}
        <h3 className="text-xl font-bold text-blue-700 m-0 mb-4" data-id="element-255">
          MEGAPACK KINESIOLOGÍA: CARRERA RESUELTA
        </h3>

        {/* Description */}
        <p className="max-w-2xl text-gray-800 m-0 mb-8 text-[14px]" data-id="element-256">
          <strong data-id="element-257">
            6 Tomos + 6 Bonos — Sistema de Estudio Completo — Toda la carrera
            resuelta.
          </strong>
          <br data-id="element-258" />
          +360 páginas · De Morfofisiología al Título · Biomecánica, Agentes
          Físicos y Clínica Kinésica · Casos clínicos resueltos · Guías de
          prácticas hospitalarias · Protocolos y parámetros listos · Material de
          TPs y exámenes · 100% adaptado al plan de estudios argentino.
        </p>

        {/* Tomes Grid */}
        <div className="relative mx-auto max-w-3xl mb-12" data-id="element-259">
          <div className="grid grid-cols-6 gap-3" data-id="element-260">
            {tomes.map(tome => <div key={tome.label} className="flex flex-col items-center gap-2" data-id="element-261">
                <div className="w-full aspect-[3/4] rounded-xl overflow-hidden shadow-lg border border-gray-100" data-id="element-262">
                  <img src={tome.image} alt={`${tome.label} — ${tome.sublabel}`} width={180} height={240} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-263" />
                </div>
                <div className="text-center" data-id="element-264">
                  <span className="block text-[11px] sm:text-xs font-black text-gray-900" data-id="element-265">
                    {tome.label}
                  </span>
                  <span className="block text-[9px] sm:text-[10px] text-gray-500 leading-tight mt-0.5" data-id="element-266">
                    {tome.sublabel}
                  </span>
                </div>
              </div>)}
          </div>

          {/* Badge inferior */}
          <div className="mt-6 flex justify-center" data-id="element-267">
            <div className="whitespace-nowrap bg-blue-700 text-[10px] font-black text-white rounded-full px-4 py-1.5 shadow-sm" data-id="element-268">
              6 TOMOS COMPLETOS · DE MORFOFISIOLOGÍA AL TÍTULO
            </div>
          </div>
        </div>

        {/* Feature Tags */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-2xl mx-auto" data-id="element-269">
          {features.map(feature => <div key={feature} className="flex items-center gap-2.5 bg-blue-700/5 border border-blue-700/20 rounded-xl px-4 py-3 text-left" data-id="element-270">
              <span className="flex-shrink-0 w-5 h-5 rounded-full bg-blue-700/15 flex items-center justify-center" data-id="element-271">
                <svg className="w-3 h-3 text-blue-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-272">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-273" />
                </svg>
              </span>
              <span className="text-xs font-semibold text-gray-800 leading-snug" data-id="element-274">
                {feature}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}